// extracted by mini-css-extract-plugin
module.exports = {"clearAllButton":"clearall_clearAllButton__2-o-3"};